module.exports = __webpack_public_path__ + "img/2_63.0300fb95.png";